<template>
  <div class="changeProjectMaterialsModal">
    <p style="margin-bottom: 5px;">Заменить на:</p>
    <CustomTable
      v-if="this.data.materials?.length"
      title=""
      :rowsData="this.data.materials || []"
      :columns="[{}, {}]"
      :hideTopTitle="true"
      :custom-body="true"
      :bottomRow="true"
      :allWidth="true"
      :striped="true"
      :bordered="true"
      :hoverless="true"
      :withoutHead="true"
      :sticky-header="false"
      separator="cell"
    >
      <template #customBody="props">
        <q-tr
          :props="props"
          :style="(this.activeMaterialId === props.row.material_id) ? 'background: rgb(189, 215, 255);' : ''"
        >
          <q-td
            align="left"
            vertical-align="center"
            style="border-left:1px solid rgba(0,0,0,.12);"
          >
            {{ props.row.material_name }}
          </q-td>
          <q-td
            align="center"
            vertical-align="center"
            style="width:150px; border-left:1px solid #e0e0e0;"
          >
            <Clickable
              @click="this.getEntrances(props.row.material_id)"
              :disable="this.disableAvailable"
            >
              Выбрать подъезды

              <q-popup-proxy
                :ref="`popup${props.row.material_id}`"
                transition-show="scale"
                transition-hide="scale"
                :breakpoint="0"
              >
                <ChangeMaterialsList
                  :alt="true"
                  :isFetching="this.isFetching"
                  :list="this.entrances"
                  :onSubmit="(selected) => this.handleSubmit(props.row.material_id, selected)"
                />
              </q-popup-proxy>
            </Clickable>
          </q-td>
        </q-tr>
      </template>
    </CustomTable>
  </div>
</template>
<script>

import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import Clickable from '@/components/common/Clickable.vue';
import ChangeMaterialsList from "@/views/ProjectsEntry/ChangeMaterialsList.vue";
import { getProjectEntrances } from "@/views/ProjectsEntry/services";

export default {
  name: "change-project-materials",
  components: {CustomTable, CustomTableCell, Clickable, ChangeMaterialsList},
  props: ['data'],
  data() {
    return {
      isFetching: false,
      entrances: [],
      activeMaterialId: null
    }
  },
  methods: {
    async getEntrances(material_id) {
      this.activeMaterialId = material_id
      if(this.entrances?.length) return
      this.isFetching = true
      const res = await getProjectEntrances(this.data.projectId)
      this.isFetching = false
      this.entrances = res || []
    },
    async handleSubmit(...args) {
      if(!this.data.onSubmit) return
      const [material_id] = args
      const res = await this.data?.onSubmit(...args)
      if(res) {
        if(this.$refs[`popup${material_id}`])
          this.$refs[`popup${material_id}`].hide()
      }
    },
  },
}
</script>

<style scoped lang="scss">
.changeProjectMaterialsModal {
  min-width: 350px;
  max-width: 800px;

  @media (max-width: 428px) {
    min-width: 100%;
    max-width: unset;
  }
}
</style>
